export class PasswordSanitizer
{
    public static Sanitize(password: string): string
    {
        return password?.trim()?.toLowerCase()?.replace(/[_\s\t\n]+/g, '_') ?? "";
    }
}

export class PasswordNormalizer
{
    public static Normalize(password: string): string
    {
        return password?.trim()?.toLowerCase()?.replace(/[\s\t\n]+/g, '').replace(/[_]+/g, ' ') ?? "";
    }
}
